import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
	name: 'copoSafeUrl',
})
export class SafeUrlPipe implements PipeTransform {
	constructor(private readonly sanitized: DomSanitizer) {}
	transform(value: string) {
		// eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
		return this.sanitized.bypassSecurityTrustUrl(value);
	}
}
